<body class="ltr  leftmenu">
    <form autocomplete="off" novalidate [formGroup]="complaintForm">
        <div class="card-body pb-0">
            <div class="receipt ">
                <div class="row ">
                    <div class="col-sm-12">
                        <img src="../../assets/images/logo-light.png" class="header-brand-img reciptLogo desktop-logo"
                            alt="logo">
                        <h4 class="mra">{{InstuName}}</h4>
                        <h5 class="mra1">Student Complaint Form</h5>
                    </div>
                </div>
                <div class="scroll" style="max-height: 400px; overflow-y: auto;">
                    <div class="row">
                        <div class="receipt-details">
                            <div class="row">
                                <div class="col-sm-12 ">
                                    <p><b>Student Name: </b>{{StuFullName}}</p>
                                </div>
                            </div>
                            <!-- <div class="row">
                                <div class="col-sm-6">
                                    <p><b>Address: </b>{{this.address}}</p>
                                </div>
                                <div class="col-sm-6">
                                    <p><b>City/State/Pincode: </b>{{this.city}}/{{this.state}}/{{this.pincode}}</p>
                                </div>
                            </div> -->
                            <div class="row">
                                
                                <div class="col-sm-6" *ngIf="PreFix != ''">
                                    <p><b>Rg No/PRN No.:</b>{{PreFix}}/{{formattedPrn}}</p>
                                </div>
                                <div class="col-sm-6" *ngIf="PreFix == '' ">
                                    <p><b>Rg No/PRN No.:</b>{{formattedPrn}}</p>
                                </div>
                                <div class="col-sm-6">
                                    <p><b>Session: </b>{{session}}</p>
                                </div>

                            </div>
                            <div class="row">
                                <div class="col-sm-6">
                                    <p><b>Mobile Phone Number: </b>{{this.Number}}</p>
                                </div>
                                <div class="col-sm-6">
                                    <p><b>Course: </b>{{this.Course}}</p>
                                </div>
                            </div>
                        </div>
                        <div class="receipt-details">

                            <div class="row">
                                <div class="col-sm-4 mt-2 mb-2">
                                    <mat-form-field appearance="outline" class="example-full-width">
                                        <mat-label> Department </mat-label>
                                        <mat-select #select583 class="colorblack" formControlName="DepartmentID"
                                            (selectionChange)="onDepartmentChange($event.value)">
                                            <mat-select-filter *ngIf="select583.focused" [placeholder]="'Filter'"
                                                [displayMember]="'DepartmentName'" [array]="departmentList"
                                                (filteredReturn)="filterdepartmentList =$event"></mat-select-filter>
                                            <mat-option *ngFor="let item of filterdepartmentList"
                                                [value]="item.DepartmentID">
                                                {{item.DepartmentName}}
                                            </mat-option>
                                        </mat-select>
                                        <mat-error class="margin_tp aline"
                                            *ngIf="complaintForm.controls['DepartmentID'].touched && complaintForm.controls['DepartmentID'].errors?.required">
                                            Mandatory
                                        </mat-error>

                                    </mat-form-field>
                                </div>
                                <div *ngIf="showOtherTextArea" class="col-sm-4">
                                    <mat-form-field appearance="outline" class="example-full-width">
                                        <mat-label>Specify Other Department</mat-label>
                                        <textarea matInput></textarea>
                                    </mat-form-field>
                                </div>
                            </div>
                        </div>
                        <div class="receipt-details">
                            <div class="row">
                                <div class="col-sm-6 mt-2 mb-2">
                                    <mat-form-field appearance="outline" class="example-full-width">
                                        <mat-label>Grievance Title</mat-label>
                                        <input matInput formControlName="GrievanceTitle">
                                        <mat-error class="margin_tp aline"
                                            *ngIf="complaintForm.controls['GrievanceTitle'].touched && complaintForm.controls['GrievanceTitle'].errors?.required">
                                            Mandatory
                                        </mat-error>
                                    </mat-form-field>
                                </div>
                            </div>
                        </div>

                        <div class="receipt-details">
                            <div class="row">
                                <div class="col-sm-12 mt-2 mb-2">
                                    <mat-form-field appearance="outline" class="example-full-width">
                                        <mat-label>Describe your concern/complaint in detail</mat-label>
                                        <textarea matInput formControlName="GrievanceDescription" rows="4"
                                            maxlength="500"
                                            placeholder="Describe your concern/complaint in detail.Include date/s of occurrence."
                                            class="form-control"></textarea>
                                        <mat-error class="margin_tp aline"
                                            *ngIf="complaintForm.controls['GrievanceDescription'].touched && complaintForm.controls['GrievanceDescription'].errors?.required">
                                            Mandatory
                                        </mat-error>
                                    </mat-form-field>
                                </div>
                            </div>
                        </div>
                        <div class="receipt-details">
                            <div class="row">
                                <div class="col-sm-12">
                                    <p><b>Have you made an attempt to resolve this concern/complaint with the individual
                                            and/or department involved?</b></p>
                                </div>

                            </div>
                            <mat-error class="margin_tp"
                                *ngIf="complaintForm.controls['PreviousAttempt'].touched && complaintForm.controls['PreviousAttempt'].errors?.required">
                                Mandatory
                            </mat-error>
                            <div class="row">
                                <mat-radio-group formControlName="PreviousAttempt" class="example-full-width">
                                    <div class="col-sm-6">
                                        <mat-radio-button value='yes'
                                            (change)="onOptionChange($event)">Yes</mat-radio-button>
                                    </div>
                                    <div class="col-sm-6">
                                        <mat-radio-button value='no'
                                            (change)="onOptionChange($event)">No</mat-radio-button>
                                    </div>
                                </mat-radio-group>
                                <mat-form-field *ngIf="complaintForm.get('PreviousAttempt').value === 'yes'"
                                    appearance="outline" class="example-full-width">
                                    <mat-label>Previous Attempt Details</mat-label>
                                    <textarea matInput formControlName="PreviousAttemptDetail" rows="4" maxlength="500"
                                        placeholder="Enter details here" class="form-control"></textarea>
                                </mat-form-field>

                            </div>
                            <div class="row">
                                <div class="col-sm-12">
                                    <p><b>If yes,describe the outcome(attach any additional comments,if necessary):</b>
                                    </p>
                                </div>

                            </div>
                        </div>

                        <div class="receipt-details">
                            <div class="row">
                                <div class="col-sm-12">

                                    <p>
                                        <mat-checkbox required class="example-full-width mr" formControlName="checkbox">
                                        </mat-checkbox>
                                        <b>I understand that information contained in the concern/complaint form will be
                                            held confidential to the xetent possible.Information may be shared with
                                            university
                                            officials in order to conduct a thorough investigation.I hereby declare that
                                            the
                                            information on this form is true,correct and complete to the best of my
                                            knowledge.
                                            I understand that any misrepresentation of information may result in
                                            disciplinary
                                            actions,in accordance with university disciplinary procedures.
                                        </b>
                                        <mat-error class="margin_tp"
                                            *ngIf="complaintForm.controls['checkbox'].touched && complaintForm.controls['checkbox'].errors?.required">
                                            Mandatory
                                        </mat-error>

                                    </p>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <button type="button" *ngIf="submitButton" class="btn btn-primary btn-icon-text floatright fr sz mt-2" (click)="submit()">
                <span style="display: contents; align-items: center;">
                    <img width="20vh" src="../../assets/images/save.gif" style="margin-right: 5px;">
                    Save
                </span>
            </button>
            <button id="Back" type="button" [mat-dialog-close]="true"
                class="btn btn-primary btn-icon-text floatright mt-2">
                <span style="display: contents; align-items: center;">
                    <img width="20vh" src="../../assets/img/turn-left.gif" style="margin-right: 7px;">
                    Back
                </span>
            </button>
        </div>
    </form>
</body>